'use client';

import { useMemo } from 'react';
import { useTranslations } from 'next-intl';
import type { UnverifiedAssetStatus } from '@terra/shared-contracts-assets';
import { Filter } from '../../../components/filter';
import {
  UNVERIFIED_ASSET_STATUS_FILTER_ORDER,
  parseUnverifiedAssetStatuses,
  resolveUnverifiedAssetStatusLabelKey,
} from '../utils/unverified-asset-status.utils';

type UnverifiedAssetStatusFilterProps = {
  value: UnverifiedAssetStatus[];
  onValueChange: (statuses: UnverifiedAssetStatus[]) => void;
};

export function UnverifiedAssetStatusFilter({
  value,
  onValueChange,
}: UnverifiedAssetStatusFilterProps) {
  const t = useTranslations('designSystem.applicationAssets');
  const items = useMemo(
    () =>
      UNVERIFIED_ASSET_STATUS_FILTER_ORDER.map((status) => ({
        label: t(
          resolveUnverifiedAssetStatusLabelKey({ unverifiedStatus: status }),
        ),
        value: status,
      })),
    [t],
  );

  return (
    <Filter
      id="unverified-status"
      density="compact"
      isMultiSelect
      placeholder={t('unverifiedStatusFilter')}
      items={items}
      value={value}
      onChange={(statuses) =>
        onValueChange(parseUnverifiedAssetStatuses(statuses))
      }
    />
  );
}
